import http from '../http-commons'

class UpdatesDataService {
	createUser(userInfo) {
		return http.post('/users', {
			username: userInfo.username,
			password: userInfo.password,
			email: userInfo.email
		})	
	}
	
	getAll() {
		return http.get("/users");
	}

	getUser(user) {
		return http.get('/users/search', { params: { username: user } })
	}
}

export default new UpdatesDataService();